// **************************************************
// Scroll to top
// **************************************************

attachEvent('.go-to-top', 'click', (ev) => {
  document.body.scrollIntoView({ behavior: 'smooth' }, true);
  ev.preventDefault();
});
